<span class=progress-bar-text attr.aria-label="{{'oska.competition_introduction_label' | translate}}"
innerHtml="{{'oska.competition_introduction_label' | translate}}"></span>
@if (level) {
  <progress-bar [id]="level" [level]="level"
    statusLabel="{{ competitionLabels[level - 1] | translate }}"
    startLabel="{{'oska.simple' | translate}}"
    endLabel="{{'oska.difficult' | translate}}">
  </progress-bar>
}
